module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9986843e072a3fa6cd2.worker.js");
};